import { Controller } from "@hotwired/stimulus"
import { showToast } from "../lib/toast"

// Manual "Send to {Provider}" trigger from a project's Pay Request or
// Change Order page. The button carries the full sync URL on
// `data-erp-sync-url-param` (built server-side via the per-kind route
// helper) so this controller stays decoupled from URL construction.
export default class extends Controller {
  static targets = ["manualMarkModal"]
  static values = {
    sequence: Number
  }

  openManualMark(event) {
    const id = event.currentTarget.dataset.modalIdParam
    if (!id) return
    document.getElementById(id)?.classList.remove("hidden")
  }

  async submitManualMark(event) {
    event.preventDefault()
    const form = event.currentTarget
    const url = form.dataset.erpSyncUrlParam
    const providerName = form.dataset.erpSyncProviderNameParam || "ERP"
    const modalId = form.dataset.erpSyncModalIdParam
    if (!url) return

    const submitBtn = form.querySelector('button[type="submit"]')
    if (submitBtn) submitBtn.disabled = true

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const resp = await fetch(url, {
        method: "POST",
        body: new FormData(form),
        headers: { "Accept": "application/json", "X-CSRF-Token": csrfToken || "" }
      })
      const payload = await resp.json().catch(() => ({}))
      if (!resp.ok || payload.ok === false) {
        showToast(payload.message || `Couldn't mark synced to ${providerName}.`, "error")
        if (submitBtn) submitBtn.disabled = false
        return
      }
      try {
        sessionStorage.setItem("pendingFlash",
          JSON.stringify({ message: payload.message || "Marked.", type: "notice" }))
      } catch (_) { /* ignore */ }
      if (modalId) document.getElementById(modalId)?.classList.add("hidden")
      setTimeout(() => window.location.reload(), 600)
    } catch (_) {
      showToast(`Network error marking synced to ${providerName}.`, "error")
      if (submitBtn) submitBtn.disabled = false
    }
  }

  async send(event) {
    const button = event.currentTarget
    const url = button.dataset.erpSyncUrlParam
    const providerName = button.dataset.erpSyncProviderNameParam || "ERP"
    if (!url || !this.sequenceValue) return

    button.disabled = true
    const originalLabel = button.innerHTML
    button.innerHTML = `Sending…`

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    let payload = null
    try {
      const resp = await fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken || ""
        }
      })
      payload = await resp.json().catch(() => ({}))
      if (!resp.ok || payload.ok === false) {
        showToast(payload.message || `Couldn't queue sync to ${providerName}.`, "error")
        button.disabled = false
        button.innerHTML = originalLabel
        return
      }
      const successMessage = payload.message || `Queued for sync to ${providerName}.`
      showToast(successMessage)
      // Persist across the reload so the toast survives the badge refresh.
      try {
        sessionStorage.setItem("pendingFlash",
                               JSON.stringify({ message: successMessage, type: "notice" }))
      } catch (_) { /* ignore */ }
      setTimeout(() => window.location.reload(), 1200)
    } catch (err) {
      showToast(`Network error queuing sync to ${providerName}.`, "error")
      button.disabled = false
      button.innerHTML = originalLabel
    }
  }
}
